import { render } from "./media-carousel.vue?vue&type=template&id=1bf11f80"
import script from "./media-carousel.vue?vue&type=script&lang=js"
export * from "./media-carousel.vue?vue&type=script&lang=js"

import "./media-carousel.vue?vue&type=style&index=0&id=1bf11f80&lang=scss"

import exportComponent from "/Users/connoringold/Documents/projects/bao/toteme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__